<template id="v4-exploratory-screen">
    <section>
        <b-alert
                :show="dismissCountDown"
                dismissible
                variant="Success"
                @dismissed="dismissCountDown=0">
            Record Saved Successfully
        </b-alert>
        <b-alert
                :show="dismissCountDownUpdated"
                dismissible
                variant="Warning"
                @dismissed="dismissCountDown=0">
            Record Updated Successfully
        </b-alert>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5 ml-2">
                <div class="card">
                    <div class="card-header text-left">
                        <i class="fa fa-searchengin"></i>
                        Visualisation Config Screen
                    </div>
                    <div class="row">
                        <!--Free Form Search-->
                        <div class="col-md-4 col-lg-3 text-left ml-4">
                            <label>Search</label>
                            <input type="text" v-model="s0" class="form-control" placeholder="Search">
                        </div>
                        <!--Filters-->
                        <div class="col-md-4 col-lg-3 text-left">

                            <label>Menu Name</label>
                            <v-select v-model="s1" :options="menuName1" @input="filteredSubMenuName(s1)"></v-select>
                        </div>
                        <div class="col-md-4 col-lg-3 text-left">
                            <label>Screen Name</label>
                            <v-select v-model="s2" :options="subMenuName1"></v-select>
                        </div>
                        <div>
                            <button class="btn btn-sm btn-info" style="margin-top: 35px"
                                    v-on:click="loadFilteredData(s1,s2)">
                                <i class="fa fa-refresh"></i>
                                Filter
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="thead-dark">
                                <tr class="text-center">
                                    <th>Menu</th>
                                    <th>Viz Unit</th>
                                    <th>Color</th>
                                    <th>Size</th>
                                    <th>Dim</th>
                                    <th>Axis Dsiplay</th>
                                    <!-- <th>Visible Flag</th>-->
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(x,idx) in filteredResources">
                                    <tr :value="x" v-bind:key="idx"
                                        :class="{ opened: opened.includes(x.syspk) }">
                                        <td>
                                            <span class="font">Menu Id:</span><span
                                                class="color" :class="{ highLightedC: highLightedC.includes(x.menuId)}">{{x.menuId}}</span><br>
                                            <span class="font">Menu Name:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.menuName)}">{{x.menuName}}</span><br>
                                            <span class="font">Sub Id:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.subMenuId)}">{{x.subMenuId}}</span><br>
                                            <span class="font">Sub Menu name:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.screenName)}">{{x.screenName}}</span>
                                        </td>
                                        <td>
                                            <span class="font">Viz Unit:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.vizunit)}"> {{x.vizunit}}</span><br>
                                            <span class="font">Viz Name:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.vizname)}"> {{x.vizname}}</span><br>
                                            <span class="font">Viz Tooltip:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.titleToolTip)}"> {{x.titleToolTip}}</span><br>
                                            <span class="font">Viz Title:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.vizTitle)}"> {{x.vizTitle}}</span><br>
                                            <span class="font">Viz Type:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.vizType)}"> {{x.vizType}}</span><br>
                                            <span class="font">Viz Type Id:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.vizTypeId)}"> {{x.vizTypeId}}</span>
                                        </td>
                                        <td>
                                            <span class="font">Y1 Color Lib:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y1_colorLibrary)}">{{x.y1_colorLibrary}}</span><br>
                                            <span class="font">Y2 Color Lib:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y2_colorLibrary)}">{{x.y2_colorLibrary}}</span><br>
                                            <span class="font">Y1 Color Range:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y1_colorRange)}">{{x.y1_colorRange}}</span><br>
                                            <span class="font">Y2 Color Range:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y2_colorRange)}">{{x.y2_colorRange}} </span><br>
                                        </td>
                                        <td>
                                            <span class="font">Width:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.width)}">{{x.width}} </span><br>
                                            <span class="font">Height:</span><span
                                                class="color" :class="{ highLightedC: highLightedC.includes(x.height)}">{{x.height}} </span><br>
                                            <span class="font">PM Top:</span>
                                            <span class="color"
                                                  :class="{ highLightedC: highLightedC.includes(x.pmTop)}">{{x.pmTop}} </span><br>
                                            <span class="font">PM Bottom:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.pmBottom)}">{{x.pmBottom}} </span><br>
                                            <span class="font">PM Left:</span><span
                                                class="color" :class="{ highLightedC: highLightedC.includes(x.pmLeft)}">{{x.pmLeft}}</span><br>
                                            <span class="font">PM Right:</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.pmRight)}"> {{x.pmRight}} </span><br>

                                        </td>
                                        <td>
                                            <span class="font">x1 Metric Tooltip:</span><span class="color"
                                                                                              :class="{ highLightedC: highLightedC.includes(x.x1_metricTooltip)}">{{x.x1_metricTooltip}}</span>
                                            <br>
                                            <span class="font">x2 Metric Tooltip:</span><span class="color"
                                                                                              :class="{ highLightedC: highLightedC.includes(x.x2_metricTooltip)}">{{x.x2_metricTooltip}}</span>
                                            <br>
                                            <span class="font">Y1 Metric Tooltip:</span><span class="color"
                                                                                              :class="{ highLightedC: highLightedC.includes(x.y1_metricTooltip)}">{{x.y1_metricTooltip}}</span>
                                            <br>
                                            <span class="font">Y2 Metric Tooltip:</span><span class="color"
                                                                                              :class="{ highLightedC: highLightedC.includes(x.y2_metricToolTip)}">{{x.y2_metricToolTip}}</span>
                                            <br>
                                        </td>
                                        <td>
                                            <span class="font">X1 Axis :</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.x1_axisDisplayName)}">{{x.x1_axisDisplayName}}</span><br>
                                            <span class="font">X2 Axis :</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.x2_axisDisplayName)}">{{x.x2_axisDisplayName}}</span><br>
                                            <span class="font">Y1 Axis :</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y1_axisDisplayName)}">{{x.y1_axisDisplayName}}</span><br>
                                            <span class="font">Y2 Axis :</span><span
                                                class="color"
                                                :class="{ highLightedC: highLightedC.includes(x.y2_axisDisplayName)}">{{x.y2_axisDisplayName}}</span><br>
                                        </td>
                                        <!--  <td>{{x.visibleFlag}}</td>-->
                                        <td class="text-center">
                                            <div class="btn-group">
                                                <button class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                                                        title="Add"
                                                        v-on:click="showRow(x.syspk)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                                <button class="btn btn-sm btn-outline-warning" size="sm"
                                                        v-b-tooltip.hover
                                                        title="Edit" v-on:click="edit(x.syspk)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr :key="x.idx" class="brdr table-borderless"
                                        v-if="showInputfield && x.syspk == editableId">
                                        <th class="mt-2" style="font-size: 18px">Edit Record</th>
                                        <th class="mt-2"></th>
                                        <th class="mt-2"></th>
                                        <th class="mt-2"></th>
                                        <th class="mt-2"></th>
                                        <th class="mt-2"></th>
                                        <th class="mt-2"></th>
                                    </tr>
                                    <template v-if="showInputfield && x.syspk == editableId">
                                        <tr :key="x.idx"
                                            style="background-color: #F0FEFE;font-size: 12px;border: 2px solid #00F9F9">
                                            <td>
                                                <label>Menu Id</label>
                                                <input type="number"
                                                       v-model="x.menuId"
                                                       class="form-control" :disabled="true" v-b-tooltip.hover
                                                       title="Only Numbers Can be Inserted">
                                                <label>Menu Name</label>
                                                <input type="text"
                                                       v-model="x.menuName"
                                                       class="form-control" :disabled="true">
                                                <label>Sub Menu Id</label>
                                                <input type="text"
                                                       v-model="x.subMenuId"
                                                       class="form-control" :disabled="true">
                                                <label>Sub Menu Name</label>
                                                <input type="text"
                                                       v-model="x.screenName"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Viz Unit</label>
                                                <input type="text"
                                                       v-model="x.vizunit"
                                                       class="form-control" :disabled="true">
                                                <label>Viz Type</label>
                                                <input type="text"
                                                       v-model="x.vizname"
                                                       class="form-control" @input="toggle(x.vizname)"
                                                       :class="{ highLightedC: highLightedC.includes(x.vizname)}">
                                                <label>Viz Tooltip</label>
                                                <input type="text"
                                                       v-model="x.titleToolTip"
                                                       class="form-control" @input="toggle(x.titleToolTip)"
                                                       :class="{ highLightedC: highLightedC.includes(x.titleToolTip)}">
                                                <label>Viz Title</label>
                                                <input type="text"
                                                       v-model="x.vizTitle"
                                                       class="form-control" @input="toggle(x.vizTitle)"
                                                       :class="{ highLightedC: highLightedC.includes(x.vizTitle)}">
                                                <label>Viz Type</label>
                                                <v-select v-model="x.vizType" :options="vizType"
                                                          @input="toggle(x.vizType)"
                                                          :class="{ highLightedC: highLightedC.includes(x.vizType)}"
                                                          style="background-color: white"></v-select>
                                                <label>Viz Type Id</label>
                                                <input type="text"
                                                       v-model="x.vizTypeId"
                                                       class="form-control" @input="toggle(x.vizTypeId)"
                                                       :class="{ highLightedC: highLightedC.includes(x.vizTypeId)}">
                                            </td>
                                            <td><label>Y1 Color Lib</label>
                                                <input type="text"
                                                       v-model="x.y1_colorLibrary"
                                                       class="form-control" @input="toggle(x.y1_colorLibrary)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y1_colorLibrary)}">
                                                <label>Y2 Color Lib</label>
                                                <input type="text"
                                                       v-model="x.y2_colorLibrary"
                                                       class="form-control" @input="toggle(x.y2_colorLibrary)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y2_colorLibrary)}">
                                                <label>Y1 Color Range</label>
                                                <input type="text"
                                                       v-model="x.y1_colorRange"
                                                       class="form-control" @input="toggle(x.y1_colorRange)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y1_colorRange)}">
                                                <label>Y2 Color Range</label>
                                                <input type="text"
                                                       v-model="x.y2_colorRange"
                                                       class="form-control" @input="toggle(x.y2_colorRange)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y2_colorRange)}">
                                            </td>
                                            <td>
                                                <div class="t-scroll">
                                                    <label>Width</label>
                                                    <input type="number"
                                                           v-model="x.width"
                                                           class="form-control" @input="toggle(x.width)"
                                                           :class="{ highLightedC: highLightedC.includes(x.width)}">
                                                    <label>Height</label>
                                                    <input type="number"
                                                           v-model="x.height"
                                                           class="form-control" @input="toggle(x.height)"
                                                           :class="{ highLightedC: highLightedC.includes(x.height)}">
                                                    <label>PM Top</label>
                                                    <input type="number"
                                                           v-model="x.pmTop"
                                                           class="form-control" @input="toggle(x.pmTop)"
                                                           :class="{ highLightedC: highLightedC.includes(x.pmTop)}">
                                                    <label>PM Bottom</label>
                                                    <input type="number"
                                                           v-model="x.pmBottom"
                                                           class="form-control" @input="toggle(x.pmBottom)"
                                                           :class="{ highLightedC: highLightedC.includes(x.pmBottom)}">
                                                    <label>PM Left</label>
                                                    <input type="number"
                                                           v-model="x.pmLeft"
                                                           class="form-control" @input="toggle(x.pmLeft)"
                                                           :class="{ highLightedC: highLightedC.includes(x.pmLeft)}">
                                                    <label>PM Right</label>
                                                    <input type="number"
                                                           v-model="x.pmRight"
                                                           class="form-control" @input="toggle(x.pmRight)"
                                                           :class="{ highLightedC: highLightedC.includes(x.pmRight)}">
                                                </div>
                                            </td>
                                            <td>
                                                <label>X1 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="x.x1_metricTooltip"
                                                       class="form-control" @input="toggle(x.x1_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(x.x1_metricTooltip)}">
                                                <label>X2 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="x.x2_metricTooltip"
                                                       class="form-control" @input="toggle(x.x2_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(x.x2_metricTooltip)}">
                                                <label>Y1 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="x.y1_metricTooltip"
                                                       class="form-control" @input="toggle(x.y1_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y1_metricTooltip)}">
                                                <label>Y2 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="x.y2_metricTooltip"
                                                       class="form-control" @input="toggle(x.y2_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y2_metricTooltip)}">
                                            </td>
                                            <td>
                                                <label>X1 Axis</label>
                                                <input type="text"
                                                       v-model="x.x1_axisDisplayName"
                                                       class="form-control" @input="toggle(x.x1_axisDisplayName)"
                                                       :class="{ highLightedC: highLightedC.includes(x.x1_axisDisplayName)}">
                                                <label>X2 Axis</label>
                                                <input type="text"
                                                       v-model="x.x2_axisDisplayName"
                                                       class="form-control" @input="toggle(x.x2_axisDisplayName)"
                                                       :class="{ highLightedC: highLightedC.includes(x.x2_axisDisplayName)}">
                                                <label>Y1 Axis</label>
                                                <input type="text"
                                                       v-model="x.y1_axisDisplayName"
                                                       class="form-control" @input="toggle(x.y1_axisDisplayName)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y1_axisDisplayName)}">
                                                <label>Y2 Axis</label>
                                                <input type="text"
                                                       v-model="x.y2_axisDisplayName"
                                                       class="form-control" @input="toggle(x.y2_axisDisplayName)"
                                                       :class="{ highLightedC: highLightedC.includes(x.y2_axisDisplayName)}">
                                            </td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-outline-primary"
                                                        v-on:click="updateExploratory(x)"
                                                        v-b-tooltip.hover
                                                        title="Save">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                                <button class="btn btn-sm btn-danger" v-on:click="hideR(e,x)"
                                                        v-b-tooltip.hover
                                                        title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="showInput && x.syspk == savetableId">
                                        <tr :key="x.idx" class="brdr table-borderless">
                                            <th class="mt-2" style="font-size: 18px">New Record</th>
                                            <th class="mt-2"></th>
                                            <th class="mt-2"></th>
                                            <th class="mt-2"></th>
                                            <th class="mt-2"></th>
                                            <th class="mt-2"></th>
                                            <th class="mt-2"></th>
                                        </tr>
                                        <tr :key="x.idx"
                                            style="background-color: #F0FEFE;font-size: 12px;border: 2px solid #00F9F9">
                                            <td>
                                                <label>Menu Id</label>
                                                <input type="number"
                                                       v-model="e.menuId"
                                                       class="form-control" v-b-tooltip.hover
                                                       title="Only Numbers Can be Inserted">
                                                <label>Menu Name</label>
                                                <input type="text"
                                                       v-model="e.menuName"
                                                       class="form-control">
                                                <label>Sub Menu Id</label>
                                                <input type="number"
                                                       v-model="e.subMenuId"
                                                       class="form-control" v-b-tooltip.hover
                                                       title="Only Numbers Can be Inserted">
                                                <label>Sub Menu Name</label>
                                                <input type="text"
                                                       v-model="e.screenName"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Viz Unit</label>
                                                <input type="text"
                                                       v-model="e.vizunit"
                                                       class="form-control">
                                                <label>Viz Type</label>
                                                <input type="text"
                                                       v-model="e.vizname"
                                                       class="form-control">
                                                <label>Viz Tooltip</label>
                                                <input type="text"
                                                       v-model="e.titleToolTip"
                                                       class="form-control">
                                                <label>Viz Title</label>
                                                <input type="text"
                                                       v-model="e.vizTitle"
                                                       class="form-control">
                                                <label>Viz Type</label>
                                                <v-select v-model="e.vizType" :options="vizType"
                                                          @input="toggle(e.vizType)"
                                                          :class="{ highLightedC: highLightedC.includes(e.vizType)}"
                                                          style="background-color: white"></v-select>
                                                <label>Viz Type Id</label>
                                                <input type="text"
                                                       v-model="e.vizTypeId"
                                                       class="form-control">
                                            </td>
                                            <td><label>Y1 Color Lib</label>
                                                <input type="text"
                                                       v-model="e.y1ColorLibrary"
                                                       class="form-control">
                                                <label>Y2 Color Lib</label>
                                                <input type="text"
                                                       v-model="e.y2ColorLibrary"
                                                       class="form-control">
                                                <label>Y1 Color Range</label>
                                                <input type="text"
                                                       v-model="e.y1ColorRange"
                                                       class="form-control">
                                                <label>Y2 Color Range</label>
                                                <input type="text"
                                                       v-model="e.y2ColorRange"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <div class="t-scroll">
                                                    <label>Width</label>
                                                    <input type="number"
                                                           v-model="e.width"
                                                           class="form-control">
                                                    <label>Height</label>
                                                    <input type="number"
                                                           v-model="e.height"
                                                           class="form-control">
                                                    <label>PM Top</label>
                                                    <input type="number"
                                                           v-model="e.pmTop"
                                                           class="form-control">
                                                    <label>PM Bottom</label>
                                                    <input type="number"
                                                           v-model="e.pmBottom"
                                                           class="form-control">
                                                    <label>PM Left</label>
                                                    <input type="number"
                                                           v-model="e.pmLeft"
                                                           class="form-control">
                                                    <label>PM Right</label>
                                                    <input type="number"
                                                           v-model="e.pmRight"
                                                           class="form-control">
                                                </div>
                                            </td>
                                            <td>
                                                <label>X1 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="e.x1_metricTooltip"
                                                       class="form-control" @input="toggle(e.x1_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(e.x1_metricTooltip)}">
                                                <label>X2 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="e.x2_metricTooltip"
                                                       class="form-control" @input="toggle(e.x2_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(e.x2_metricTooltip)}">
                                                <label>Y1 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="e.y1_metricTooltip"
                                                       class="form-control" @input="toggle(e.y1_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(e.y1_metricTooltip)}">
                                                <label>Y2 Metric Tooltip</label>
                                                <input type="text"
                                                       v-model="e.y2_metricTooltip"
                                                       class="form-control" @input="toggle(e.y2_metricTooltip)"
                                                       :class="{ highLightedC: highLightedC.includes(e.y2_metricTooltip)}">
                                            </td>
                                            <td>
                                                <label>X1 Axis</label>
                                                <input type="text"
                                                       v-model="e.x1_axisDisplayName"
                                                       class="form-control">
                                                <label>X2 Axis</label>
                                                <input type="text"
                                                       v-model="e.x2_axisDisplayName"
                                                       class="form-control">
                                                <label>Y1 Axis</label>
                                                <input type="text"
                                                       v-model="e.y1_axisDisplayName"
                                                       class="form-control">
                                                <label>Y2 Axis</label>
                                                <input type="text"
                                                       v-model="e.y2_axisDisplayName"
                                                       class="form-control">
                                            </td>
                                            <td class="text-center">
                                                <b-button v-on:click="saveExploratory(e)" variant="outline-primary"
                                                          size="sm"
                                                          v-b-tooltip.hover
                                                          title="Save">
                                                    <i class="fa fa-save"></i>
                                                </b-button>
                                                <b-button v-on:click="hideR(e)" variant="outline-danger" size="sm"
                                                          v-b-tooltip.hover
                                                          title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'v4-exploratory-screen',
    data: function () {
      return {
        exploratoryData: [],
        sort: 'asc',
        sortBy: 'created',
        e: [],
        showInput: '',
        showInputfield: '',
        vizname: [],
        title: [],
        transporters: [],
        selected: [],
        options: [],
        editableId: [],
        dismissSecs: 1,
        dismissCountDown: 0,
        dismissCountDownUpdated: 0,
        flag: ['True', 'False'],
        options2: [],
        opened: [],
        savetableId: [],
        hideRow: [],
        menuName: [],
        l1: [],
        l2: [],
        s0: '',
        All: '',
        s1: '',
        s2: '',
        sm1: [],
        menuName1: [],
        subMenuName1: [],
        screenName: [],
        highLightedC: []
      }
    },
    computed: {
      filteredResources () {
        function compare (a, b) {
          if (a.menuName < b.menuName) return -1
          if (a.menuName > b.menuName) return 1
          return 0
        }

        return this.exploratoryData.filter(x => {
          return x.menuName.toLowerCase().includes(this.s0.toLowerCase())
        }).sort(compare)
      }
    },

    created: function () {
      this.loadExploratory()
    },
    methods: {
      //High Light Selected Row
      toggle (x) {
        console.info('Entered into toggle', x)
        const index = this.highLightedC.indexOf(x)
        console.log('the index is', index)
        this.highLightedC.push(x)
      },
      //Get Request
      loadExploratory: function () {
        console.log('v4','load state');  this.$store.dispatch("loadState").then(() => {
          this.exploratoryData = this.$store.state.fwSVizConfigScreen
          this.menuName1 = Array.from(new Set(this.exploratoryData.map(r => r.menuName)))
          this.vizType = Array.from(new Set(this.exploratoryData.map(r => r.vizType).filter(x => x != null)))
          this.sm1 = Array.from(new Set(this.exploratoryData.map(r => r.screenName).filter(x => x != null)))
          this.subMenuName1 = this.sm1
        })
      },
      loadFilteredData: function (l1, l2) {
        console.log('Loading L1 and L2 Parameter', l1, l2)
        console.log('v4-2','load state');  this.$store.dispatch("loadState").then(() => {
          this.exploratoryData = this.$store.state.fwSVizConfigScreen
          this.menuName = this.exploratoryData.filter(r => r.menuName === l1 && r.screenName === l2)
          this.exploratoryData = this.menuName
        })
      },
      filteredSubMenuName: function (fsnsm) {
        console.log('Testing Menu Parameter', fsnsm)
        this.exploratoryData = this.$store.state.fwSVizConfigScreen
        this.m1 = this.exploratoryData.filter(r => r.menuName === fsnsm)
        this.subMenuName1 = Array.from(new Set(this.m1.map(r => r.screenName).filter(x => x != null)))
        console.log('Testing something', this.m1)
      },
      //Post Request
      saveExploratory: function (e) {
        let payload = Object.assign({}, e)
        axios.post('/api/configs/config-screen/', payload)
          .then(this.loadExploratory(), e => {
            console.error('error in Saving Record', e)
          })
        this.dismissCountDown = this.dismissSecs
        this.savetableId = null
      },

      //Put/Update Request
      updateExploratory: function (x) {
        axios.put('/api/configs/config-screen/', x)
          .then(response => {
            console.log('Data Updated successfully', response)
          })
          .then(this.loadExploratory(), e => {
            console.error('error in Updating Record', e)
          })
        this.dismissCountDownUpdated = this.dismissSecs
        this.editableId = null
      },

      //Show Edit Input Field
      edit: function (syspk) {
        this.showInputfield = true
        this.editableId = syspk
        //High Light Selected Row
        this.opened.push(syspk)
      },

      //Show Row
      showRow: function (syspk) {
        this.showInput = true
        this.savetableId = syspk
        //High Light Selected Row
        this.opened.push(syspk)
      },
      show: function () {
        this.$modal.show('hello-world')
      },
      hide: function () {
        this.$modal.hide('hello-world')
      },

      //Hide Add record or save record
      hideR: function (syspk) {
        if (this.savetableId == syspk) {
          this.savetableId = null
          this.editableId = null
        } else {
          this.savetableId = syspk
          this.editableId = syspk
        }
      }
    },//Method End

  }
</script>
<style scoped>
    /*to highlight selected background*/
    .opened {
        background-color: #F0FEFE;
        border: 2px solid #00F9F9;
    }

    .t-scroll {
        display: inline-block;
        height: 260px;
        overflow-y: scroll;
    }

    .font {
        /*color: #0b58a2;*/
    }

    .color {
        font-weight: bold;
        color: dimgrey;
    }

    /*Hide up/down arrowin input fields*/
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .highLightedC {
        background-color: #E0FCFF;
        color: #D518C3;
    }

    .brdr {
        border: 2px solid #00F9F9;
    }
</style>



